// Contexto para anmazenar dados do ID do AutoComplete escolhido

import React, { createContext, useState } from "react";

export const FormaAtendProfIdContext = createContext()
export const FormaAtendProfDescrContext = createContext()

export const FormaAtendProfContextProvider = ({ children }) => {
    const [formaAtendProfIdContext, setFormaAtendProfIdContext] = useState('')
    const [formaAtendProfDescrContext, setFormaAtendProfDescrContext] = useState('')

    return (
        <FormaAtendProfIdContext.Provider value={{ formaAtendProfIdContext, setFormaAtendProfIdContext }}>
            <FormaAtendProfDescrContext.Provider value={{ formaAtendProfDescrContext, setFormaAtendProfDescrContext }}>
                {children}
            </FormaAtendProfDescrContext.Provider>
        </FormaAtendProfIdContext.Provider>
    )
}